import React from 'react';

function FeaturedOn() {
  return (
    <section className="pad60">
      <div className=" bg-lightblue">
        <div className=" featured-wrapper ">
          <heading className="heading-container">
            <h2 className="underlined-heading">As Featured On</h2>
          </heading>
          <div className="broker-img-container">
            <a href="https://alpaca.markets" target="_blank">
              <img src="/img/Alpaca.svg" alt="alpaca" />
            </a>
            <a href="https://ninjatrader.com/" target="_blank">
              <img src="/img/NinjaTrader.svg" alt="ninjaTrader" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedOn;
